import React, { type ReactElement } from 'react'

import * as styles from './link-global-ntt.module.scss'

const LinkGlobalNtt = (): ReactElement | null => {
  return (
    <div className={`${styles.linkGlobalNtt} link-global-ntt`}>
      <a href="https://www.nttdata.com/global/en/country-selector" target="">
        Global<span>Select a Country</span>
      </a>
    </div>
  )
}

export default LinkGlobalNtt
